// Mirrors backend/src/pdfTemplates/designA/designAFormatters.js's
// formatPercent exactly. Quantity/discount%/tax% fields come straight off
// DECIMAL-typed DB columns, which the API returns as strings carrying the
// column's full declared scale (e.g. "7.0000000", "1.0000000000000").
// Displaying those raw, or summing them with += without converting to a
// number first (silently falls back to string concatenation, e.g.
// 0 += "1.0000000000000" -> "01.000..."), is exactly the bug this fixes.
// Matches the legacy frontend's own exact convention (ServiceVoucherBody.jsx
// etc.): fix to 2dp, then drop a bare ".00" so whole numbers print clean.
export function formatPercent(v) {
  return Number(v || 0).toFixed(2).replace(/\.00$/, "");
}
